import {
    type MylensesManagementPageAction,
    type MylensesManagementPageActionTypes,
    type MylensesManagementPageTypes,
} from "@snapchat/blizzard-schema";

export interface ManagementPageActionEventData {
    event: MylensesManagementPageAction["event_name"];
    pageType: MylensesManagementPageTypes;
    action: MylensesManagementPageActionTypes;
}

export const createManagementPageActionEvent = (
    { event, pageType, action }: ManagementPageActionEventData,
    sessionId: string,
): MylensesManagementPageAction => ({
    event_name: event,
    page_type: pageType,
    action: action,
    mylenses_session_id: sessionId,
});
